import { all, call } from 'redux-saga/effects';
import values from 'lodash/values';
import coreSagas from 'core/sagas';
import searchHybridFormSaga from 'core/modules/HybridSearchForm/sagas';
import favoritesSaga from './favorites';

const combinedSagas = {
  ...coreSagas,
  searchHybridFormSaga,
  favoritesSaga,
};

export default function* rootSaga() {
  yield all(values(combinedSagas).map(saga => call(saga)));
}
